import { apiClient } from './api'
import type { AuthResponse } from '../types'

export async function requestMagicLink(email: string): Promise<{ status: string }> {
  const { data } = await apiClient.post<{ status: string }>('/auth/magic_link', { email })
  return data
}

export async function verifyMagicLink(token: string): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>('/auth/magic_link/verify', { token })
  return data
}
